<ng-container *transloco="let t">
  <section
    id="comingSoonBanner"
    class="coming-soon-banner"
    [class.hugescreen]="(biggerThan$ | async)?.md"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <section class="content">
      <div class="cards full-width">
        <a
          class="popsy-card"
          [routerLink]="informationPageUrlFragment('buyback')"
          [queryParams]="queryParamsToKeep$ | async"
          (click)="logOpenBuyback('homepage-banner')"
          [attr.aria-label]="t('label_credit_card_installments')"
          [style.min-height]="'150px'"
          [style.background-image]="'url(' + bannerLink() + ')'"
          [style.background-repeat]="'no-repeat'"
          [style.background-position]="'center center'"
          [style.background-size]="'cover'">
          <div class="head">
            <h2 class="title">{{ t('title_trade_in') }}</h2>

            <span class="fixed-space-8" aria-hidden="true"></span>

            <div class="button popsy-card">
              {{ t('action_trade_in') }}
            </div>
          </div>
          <!--  <app-picture [pictureUrl]="bannerLink()"></app-picture> -->
        </a>
      </div>
    </section>
  </section>
</ng-container>
